import React from 'react';
import Quiz from './quiz/Quiz';

const QuizPage: React.FC = () => {
  return <Quiz />;
};

export default QuizPage;